<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px" @change="selectTab">
      <a-tab-pane key="1" :tab="$t('business.label.itemLotQuery')" style="margin-top: -14px">
        <a-space>
          <a-input-search v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" @pressEnter="search" @search="search"/>
          <a-input-search v-model="query['item.name']" :placeholder="$t('business.label.itemName')" @pressEnter="search" @search="search"/>
          <a-input-search v-model="query['lot.no']" :placeholder="$t('business.label.lot')" @pressEnter="search" @search="search"/>
        </a-space>
        <vxe-table
          ref="lotMaintainListTable"
          :data="data"
          :keyboard-config="{isArrow: true}"
          :column-config="{resizable: true}"
          :row-config="{isCurrent: true, isHover: true}"
          :loading="loading"
          :max-height="scrollY"
          :scroll-x="{enabled: true}"
          align="center"
          border
          export-config
          round
          show-overflow
          size="mini"
          stripe
          style="margin-top: 2px"
          @cell-dblclick="lotMaintainListCellClickEvent">
          <vxe-column fixed="left" type="seq" width="40"/>
          <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
          <vxe-column field="item.name" title="business.label.ChineseName"/>
          <vxe-column field="no" title="business.label.lotNo"/>
          <vxe-column field="productionDate" title="business.label.productionDate" width="100"/>
          <vxe-column field="validUntil" title="business.label.validUntil" width="100"/>
          <vxe-column field="printProductionDate" title="business.label.printProductionDate" width="100"/>
          <vxe-column field="printValidUntil" title="business.label.printValidUntil" width="100"/>
        </vxe-table>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="handlePageChange"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('business.label.lotDetail')" style="margin-top: -14px">
        <a-spin :spinning="spinning">
          <a-form>
            <a-row>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.itemName')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.item.name" :disabled="true"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.lotNo')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.no" :disabled="true"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.productionDate')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.productionDate" :disabled="true"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.validUntil')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.validUntil" :disabled="true"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.printProductionDate')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.printProductionDate"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('business.label.printValidUntil')" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="lot.printValidUntil"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-spin>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="btExport">{{ $t('button.expConfirm') }}</a-button>
        <a-button type="primary" @click="btRefresh">{{ $t('button.refresh') }}</a-button>
        <a-button :disabled="isSave" type="primary" @click="btSave">{{ $t('button.save') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
import { findAll, save } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'LotMaintainView',
    mounted() {
      this.getData()
    },
    data() {
      return {
        activeKey: '1',
        lot: {
          item: {},
          batches: [{}]
        },
        data: [],
        page: 1,
        size: 20,
        contentSize: 0,
        query: {
          'item.no': '',
          'item.name': '',
          'lot.no': ''
        },
        isSave: true,
        loading: false,
        spinning: false,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.775),// 表格竖向滚动条,减去的数值是页面其他元素的高度
        labelCol: {span: 8},
        wrapperCol: {span: 12}
      }
    },
    methods: {
      selectTab() {
        if (this.activeKey === '2') {
          this.isSave = false
        }
      },
      btSave() {
        if (this.lot.item === undefined) {
          return this.$message.warning('请先选择商品')
        }
        this.spinning = true
        save('lotPersister', this.lot).then(res => {
          if (res.success) {
            this.lot = res.result
            this.$message.success('保存成功')
          }
        }).finally(() => {
          this.spinning = false
        })
      },
      btExport() {
        this.$refs.lotMaintainListTable.openExport({
          original: true
        })
      },
      lotMaintainListCellClickEvent({row}) {
        this.lot = row
        this.activeKey = '2'
        this.isSave = false
      },
      btRefresh() {
        this.getData()
      },
      handlePageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('lotFactory', this.query, this.page, this.size)
          .then(res => {
            if (res.success) {
              this.contentSize = res.contentSize
              this.data = res.result
            }
          }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      }
    }
  }
</script>

